// import ReportTransferAnalysis from '../components/ui/report-transfer-analysis.js';
import CurrentCaseRequired from "../components/ui/current-case-required.js";
// import MaritalBalanceSheet from "../components/ui/marital-balance-sheet.js";
import CaseMaintenanceScreen from "../components/ui/CaseMaintenanceScreen.js";
import CaseDatabaseCheck from "../components/ui/case-database-check.js";

export default function CaseMaintenancePage(props) {
    return (
        <CaseDatabaseCheck>
        <CurrentCaseRequired>
        <CaseMaintenanceScreen/>
        </CurrentCaseRequired>
        </CaseDatabaseCheck>
    );
}